var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBusOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2588 24.048C23.0157 24.5813 22.9415 25.1762 23.046 25.7529C23.1506 26.3295 23.4288 26.8605 23.8436 27.2746C24.2583 27.6887 24.7897 27.9662 25.3665 28.0698C25.9433 28.1735 26.5381 28.0983 27.071 27.8545M5.75 25.2383C5.75 26.0008 6.0529 26.732 6.59207 27.2712C7.13123 27.8104 7.8625 28.1133 8.625 28.1133C9.3875 28.1133 10.1188 27.8104 10.6579 27.2712C11.1971 26.732 11.5 26.0008 11.5 25.2383C11.5 24.4758 11.1971 23.7445 10.6579 23.2053C10.1188 22.6662 9.3875 22.3633 8.625 22.3633C7.8625 22.3633 7.13123 22.6662 6.59207 23.2053C6.0529 23.7445 5.75 24.4758 5.75 25.2383Z",
    stroke: "white",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 25.2383H2.875V9.42578C2.875 9.04453 3.02645 8.6789 3.29603 8.40932C3.56562 8.13973 3.93125 7.98828 4.3125 7.98828H7.1875M12.9375 7.98828H24.4375C28.4064 7.98828 31.625 12.4934 31.625 18.0508V25.2383H30.1875M23 25.2383H11.5",
    stroke: "white",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.98828L25.1562 18.0508H31.625M2.875 15.1758H14.375M20.125 15.1758H24.4375M10.0625 10.8633V15.1758M17.25 7.98828V12.3008M4.3125 5.11328L30.1875 30.9883",
    stroke: "white",
    strokeWidth: 2.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBusOff);
export default __webpack_public_path__ + "static/media/icon-bus-off.b86e47c97e39c399be11b6a6241525f2.svg";
export { ForwardRef as ReactComponent };